import React, { Component } from 'react';
import styled from 'styled-components';
import SpecialOffersHeroBanner from './SpecialOffersHeroBanner';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import { removeOfferById, saveOffer } from '../../../../lib/user';
import {
  GRID,
  OFFERS,
  OFFERS_LAYOUT_LOAD_INCREMENT,
} from '../../../../lib/constants';
import OfferCard from '../Offer/OfferCard';
import Button from '../Button/Button';

const PAGE_CONTEXT = 'special-offers-page';

const HiddenH1 = styled.h1`
  display: none;
`;

const LoadMoreOffersButton = styled(Button)`
  margin: ${(p) => p.theme.unit(6)} auto;
`;

class SpecialOffersContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offers: [],
      offersToLoad: [],
      offersSliceIndex: OFFERS_LAYOUT_LOAD_INCREMENT,
      moreOffers: true,
    };

    this.loadMoreOffers = this.loadMoreOffers.bind(this);
    this.shouldShowButton = this.shouldShowButton.bind(this);
  }

  componentWillMount() {
    const {
      allOffers = [],
    } = this.props;

    const offers = allOffers;
    const offersToLoad = allOffers.slice(0, this.state.offersSliceIndex);
    const newState = Object.assign({}, this.state, { offers, offersToLoad });
    this.setState(newState, this.shouldShowButton);
  }

  componentDidMount() {
    this.shouldShowButton();
  }

  shouldShowButton() {
    if (this.state.offers.length < OFFERS_LAYOUT_LOAD_INCREMENT || this.state.offers.length <= this.state.offersToLoad.length) {
      this.setState({ moreOffers: false });
    }
  }

  loadMoreOffers() {
    const offersSliceIndex = this.state.offersSliceIndex + OFFERS_LAYOUT_LOAD_INCREMENT;
    const offersToLoad = this.state.offers.slice(0, offersSliceIndex);
    const newState = Object.assign({}, this.state, { offersSliceIndex, offersToLoad });
    this.setState(newState, this.shouldShowButton);
  }

  render() {
    const {
      specialOffersData = {},
      pageStateModifiers = {},
      locale = 'en',
      userData = {},
    } = this.props;

    const {
      moreOffers,
    } = this.state;

    const {
      displayName = '',
      offersLayoutButtonText,
      tags,
      offersLayoutSectionTitle,
    } = specialOffersData;

    const favOffersIds = userData.offers && userData.offers.length ?
      userData.offers.map(offer => offer.id) : [];
    const layoutKey = 'special-offers-page-offers-module';

    const desktopPage = (
      <div>
        <HiddenH1>
          {displayName}
        </HiddenH1>
        <SpecialOffersHeroBanner seasonalPageData={specialOffersData} />
        <MaxWidthLayout key={`${layoutKey}-desktop`}>
          <LayoutCollectionView
            favItemIds={favOffersIds}
            items={this.state.offersToLoad}
            Comp={OfferCard}
            itemType={OFFERS}
            viewType={GRID}
            saveItemHandler={saveOffer}
            removeItemHandler={removeOfferById}
            pageStateModifiers={pageStateModifiers}
            locale={locale}
            tags={tags}
            sectionTitle={offersLayoutSectionTitle}
            showDisplayName
            pageContext={PAGE_CONTEXT}
          />
          {moreOffers && (
            <LoadMoreOffersButton
              variant="primary"
              size="medium"
              onClick={this.loadMoreOffers}
              buttonText={offersLayoutButtonText}
            />
          )}
        </MaxWidthLayout>
      </div>
    );

    const mobilePage = (
      <div>
        <HiddenH1>
          {displayName}
        </HiddenH1>
        <SpecialOffersHeroBanner seasonalPageData={specialOffersData} isMobile />
        <MaxWidthLayout key={`${layoutKey}-mobile`}>
          <LayoutCollectionView
            favItemIds={favOffersIds}
            items={this.state.offersToLoad}
            Comp={OfferCard}
            itemType={OFFERS}
            viewType={GRID}
            saveItemHandler={saveOffer}
            removeItemHandler={removeOfferById}
            pageStateModifiers={pageStateModifiers}
            locale={locale}
            tags={tags}
            buttonText={offersLayoutButtonText}
            sectionTitle={offersLayoutSectionTitle}
            showDisplayName
            pageContext={PAGE_CONTEXT} />
          {moreOffers && (
            <LoadMoreOffersButton
              variant="primary"
              size="medium"
              onClick={this.loadMoreOffers}
              buttonText={offersLayoutButtonText}
            />
          )}
        </MaxWidthLayout>
      </div>
    );

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={desktopPage}
        mobileChildren={mobilePage}
      />
    );

    return renderComp;
  }
}

export default SpecialOffersContent;

